export class DeleteFarmByIdUseCase {
  constructor(repository){
    this.repository=repository
  }
  async execute(id) {
    const resp= await this.repository.delete(id)
    return resp
  }
}
